import { render, staticRenderFns } from "./fertilizer-edit-form.html?vue&type=template&id=a4e20734&scoped=true&"
import script from "./fertilizer-edit-form.js?vue&type=script&lang=js&"
export * from "./fertilizer-edit-form.js?vue&type=script&lang=js&"
import style0 from "./FertilizerEditForm.vue?vue&type=style&index=0&id=a4e20734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e20734",
  null
  
)

component.options.__file = "FertilizerEditForm.vue"
export default component.exports